import { Inject } from '@angular/core';
import '@angular/compiler';
import { LayoutMainComponent } from './layout.main/layout.main.component';
import { PageRecommendComponent } from './page.recommend/page.recommend.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PageSearchComponent } from './page.search/page.search.component';
import { PageResultComponent } from './page.result/page.result.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageAdminChartsComponent } from './page.admin.charts/page.admin.charts.component';
import { PageTestComponent } from './page.test/page.test.component';
import { PageAdminSongsComponent } from './page.admin.songs/page.admin.songs.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageTestMeasureComponent } from './page.test.measure/page.test.measure.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageHomeComponent } from './page.home/page.home.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PagePracticeComponent } from './page.practice/page.practice.component';
import { LayoutAdminComponent } from './layout.admin/layout.admin.component';
import { PageFavoritesComponent } from './page.favorites/page.favorites.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PageSongDetailComponent } from './page.song.detail/page.song.detail.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url: any) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        LayoutMainComponent,
        PageRecommendComponent,
        LayoutEmptyComponent,
        PageSearchComponent,
        PageResultComponent,
        PortalSeasonLoadingSeasonComponent,
        PageAdminChartsComponent,
        PageTestComponent,
        PageAdminSongsComponent,
        PortalSeasonLoadingDefaultComponent,
        PageTestMeasureComponent,
        PortalSeasonFormDropdownComponent,
        PortalSeasonPaginationComponent,
        PortalSeasonTreeComponent,
        PageHomeComponent,
        PortalPostDetailComponent,
        PagePracticeComponent,
        LayoutAdminComponent,
        PageFavoritesComponent,
        PortalSeasonModalComponent,
        PageSongDetailComponent,
        PortalPostListComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
